import { WarcryEffect } from './warcry_effect'

export default {
    events: {},
    effects: {
        WarcryEffect
    },
    requirements: {}
}